import React from 'react';
import { Modal, FormControl, Checkbox } from 'react-bootstrap';

class BookmarkNote extends React.Component{
    constructor(props)
    {
        super(props);
        this.onEmailChecked = this.onEmailChecked.bind(this);
        this.onBookmarkClicked = this.onBookmarkClicked.bind(this);
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);

        this.onMessageTextChange = this.onMessageTextChange.bind(this);
        this.onCancelClicked = this.onCancelClicked.bind(this);

        this.state = {ShowDialog: this.props.showDialog, 
                    ClientMessage: "", 
                    submitButtonText: this.props.submitButtonText || "SEND", 
                    sendEmail: this.props.sendEmail || true, 
                    titleMessage: this.props.titleMessage,
                    isDataFetching: this.props.isDataFetching || false}  
    }
    
    onEmailChecked(e)
    {
        let self = this;
        self.setState({sendEmail: !self.state.sendEmail});
    }
    
    onMessageTextChange(e)
    {
        this.setState({ClientMessage: e.target.value});
    }

    onBookmarkClicked(e)
    {
        if(this.props.onBookmarkNoteSaved)
        {
            this.setState({isDataFetching: true});
            this.props.onBookmarkNoteSaved(this.state.ClientMessage, this.state.sendEmail, this.state.isDataFetching);   
        }
    }
    
    onCancelClicked(e)
    {
        this.setState({ShowDialog: false});
        if(this.props.onBookmarkNoteClosed)
        {
            this.props.onBookmarkNoteClosed();
        }
    }

    handleOpenDialog() {
        this.setState({
            openDialog: true
        });
    }

    handleCloseDialog() {
        this.setState({
            openDialog: false
        });
    }
    
    componentWillReceiveProps(nextProps){
        if(this.props.pageUpdatedOn !== undefined && this.props.pageUpdatedOn !== null &&
            nextProps.pageUpdatedOn !== undefined && nextProps.pageUpdatedOn !== null &&            
            JSON.stringify(this.props.pageUpdatedOn) !== JSON.stringify(nextProps.pageUpdatedOn))
        {
            this.setState({isDataFetching: nextProps.isDataFetching});
        }
    }

    render()
    {        
        return(
        <div>
            <Modal className="client_mg_popup" show={this.state.ShowDialog} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Body >
                    {this.state.titleMessage}
                    This property will be highlighted for your client in any search results and appear in their suggested by agent section.  
                    They will also receive an optional email notification with your custom message to them.
                    <FormControl disabled={this.state.isDataFetching} componentClass="textarea" style={{border: "1px solid #e5e5e5", padding: "10px", resize: "none"}} value={this.state.ClientMessage} placeholder="" onChange={this.onMessageTextChange} />
                </Modal.Body>
  
                <Modal.Footer>
                    <Checkbox inline onClick={this.onEmailChecked} checked={this.state.sendEmail} style={{float: "left",width:"100%",padding:"0px"}} disabled={this.state.isDataFetching}><span>Send client an email notification</span></Checkbox>
                    <div className="col-sm-12 tru-left">
                        <button id="bm-cancle" className="tru-btn tru-btn-theme mg-rt-10" onClick={this.onCancelClicked} disabled={this.state.isDataFetching}>Cancel</button>
                        <button id="bm-send" className="tru-btn tru-btn-theme" onClick={this.onBookmarkClicked}  disabled={this.state.isDataFetching}>{this.state.sendEmail ? "Send" : "Bookmark"}</button>
                    </div>
                </Modal.Footer>
            </Modal>            
        </div>
        )
    }
}

export default BookmarkNote;